
"use client"
import LogoImage from "../assets/Image/Logo.png"

const Footer = ({ onTermsClick, onPrivacyClick }) => {
  return (
    <footer className="py-16 bg-[#1a3324] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Side: Logo, Acknowledgement, Copyright */}
          <div className="flex flex-col items-center md:items-start space-y-6">
            {/* MW Monogram Logo */}
            <img
              src={LogoImage}
              alt="Mediwhistle Logo"
              className="h-32 object-contain"
            />
            {/* Acknowledgement of Country */}
            <div className="max-w-md text-center md:text-left">
              <p className="text-sm text-gray-400 leading-relaxed">
                Mediwhistle acknowledges Traditional Owners of Country throughout Australia and recognises the continuing
                connection to lands, waters and communities. We pay our respect to Aboriginal and Torres Strait Islander
                cultures; and to Elders past and present.
              </p>
            </div>
            {/* Copyright */}
            <div>
              <p className="text-sm text-gray-400">© 2025 Mediwhistle. All Rights Reserved.</p>
            </div>
          </div>
          {/* Right Side: Links */}
          <div className="flex items-end gap-10 md:items-end justify-end space-y-4">
            <button
              onClick={onTermsClick}
              className="text-sm text-white hover:text-emerald-200 underline transition-colors"
            >
              Terms & Conditions
            </button>
            <button
              onClick={onPrivacyClick}
              className="text-sm text-white hover:text-emerald-200 underline transition-colors"
            >
              Privacy Policy
            </button>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
